import React from "react";
import { Link } from "react-router-dom";

const PrimerConcurso = () => {
  return (
    <div className="primer-concurso">
      <h1 className="textAtomicMarker">PRIMER CONCURSO</h1>
      <h2>
        DEDICADO A <br /> <span>LOS UTILEROS DEL CARNAVAL</span>
      </h2>
      <p className="textochico">
        EN EL CARNAVAL, HAY MUCHOS LABURANTES QUE <br />
        DEJAN TODO POR EL ESPECTÁCULO DEL OTRO LADO <br />
        DEL TELÓN
      </p>
      <p className="textochico">
        <span>ROCKSTAR</span> RECONOCE A LOS <br />
        HÉROES ANÓNIMOS QUE HACEN POSIBLE <br />
        LA MAGIA DEL CARNAVAL.
      </p>
      <Link to="/grupos">
        <button>VOTÁ ACÁ POR TU UTILERÍA FAVORITA</button>
      </Link>
    </div>
  );
};

export default PrimerConcurso;
